import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Modal from "react-bootstrap/Modal";
import Select, { components } from "react-select";
import { CaretIcon, CheckIcon, CircleLoading, CloseIcon, CopyLink, DropDownIcon, EyeIcon, LinkIcon, Lock, PublicIcon } from "../../Assest/icons";
import apiClient from "../../apiClient";
import { useSelector } from "react-redux";
import { GETBOARDDETAILS, UPDATEACCESSOFUSER, UPATEBOARD, ADDNEWUSERS } from "../../apiClient/apiEndpoints";
import Skeleton from "react-loading-skeleton";
import { UNO_URL } from "../../env";
import { FaCaretDown } from 'react-icons/fa';

const ShareModal = ({ show, onHide, handleClose, shareMoadalData, getAllBoards }) => {
  const configData = useSelector((state) => state.configSlice);
  const API_URL = configData?.config?.API_URL;
  const [optionList, setOptionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(true);
  const [type, setType] = useState("READ");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [boardInfo, setBoardInfo] = useState({});
  let channels = useSelector((state) => state.userSlice.channelUsers);

  const MultiValueLabel = (props) => {
    return (
      <components.MultiValueLabel>
        <p className="label-tag">{props.data.name}</p>
      </components.MultiValueLabel>
    );
  };

  const handleSelectUsers = (selectedOptions) => {
    setSelectedUsers(selectedOptions);
  };

  const getSingleBoardDetail = async () => {
    setLoading(true);
    try {
      const data = await apiClient.get(`${API_URL}${GETBOARDDETAILS}/${shareMoadalData?.type}/${shareMoadalData?.id}`);
      setLoader(true);

      if (data) {
        setBoardInfo(() => data);
        setLoader(() => false);
        let userIdlist = data?.allocations?.map((e) => e.userId);
        let groupIdlist = data?.allocations?.map((e) => e.groupId);
        channels = channels
          ?.filter((e) => !userIdlist.includes(e.uuid))
          .filter((e) => !groupIdlist.includes(e.groupId));
        setUserList();
      }
      setLoader(false);
      setLoading(false);
    } catch (err) {}
  };

  const handleUserTypeChange = (userId, groupId, access) => {
    if (userId) {
      setBoardInfo((prev) => {
        const updated = prev.allocations.map((e) => {
          if (e.userId === userId) {
            e.access = access;
            e.change = true;
          }
          return e;
        });
        return { ...prev, allocations: updated };
      });
    } else {
      setBoardInfo((prev) => {
        const updated = prev.allocations.map((e) => {
          if (e.groupId === groupId) {
            e.access = access;
            e.change = true;
          }
          return e;
        });
        return { ...prev, allocations: updated };
      });
    }
  };

  const handleBoardPermission = (accessType) => {
    setBoardInfo((e) => {
      return { ...e, accessType: accessType };
    });
  };

  const saveBoardUsersInfo = async () => {
    try {
      setLoading(true);
      let body = {
        data: boardInfo?.allocations
          .filter((e) => e.access !== "REMOVE")
          .map((e) => {
            return { uuid: e.uuid, name: e.name, userId: e.userId, groupId: e.groupId, access: e.access };
          }),
      };
      await apiClient.put(`${API_URL}${UPDATEACCESSOFUSER}/${shareMoadalData?.id}`, body);
      await addNewUsers();
      if (boardInfo?.access === "OWNER") {
        let body = {
          accessType: boardInfo?.accessType || "PUBLIC",
        };
        await apiClient.put(`${API_URL}${UPATEBOARD}/${shareMoadalData?.id}`, body);
      }
      setLoading(false);
    } catch (error) {
    } finally {
      cleanModalData();
    }
  };

  const cleanModalData = () => {
    setBoardInfo(() => {});
    setOptionList(() => []);
    setSelectedUsers(() => []);
    onHide();
  };

  const setUserList = () => {
    let optionsList = channels?.map((e) => {
      return {
        value: e.uuid ? { uuid: e.uuid } : { groupId: e.groupId },
        name: e.name,
        label: (
          <div className="User-list" key={e?.uuid}>
            <div className="profile-img">
              {" "}
              {e?.avatar ? <img src={e?.avatar} alt="profile" /> : <span className="ini"> {e?.name?.charAt(0)} </span>}
            </div>
            <div className="name-email">
              <p className="name">{e?.name}</p>
              <p className="email">{e?.email}</p>
            </div>
          </div>
        ),
      };
    });
    setOptionList(() => optionsList);
  };

  const addNewUsers = async () => {
    try {
      if (!selectedUsers.length) return;
      const userId = selectedUsers.map((e) => e?.value?.uuid).filter((e) => e);
      const groupId = selectedUsers.map((e) => e?.value?.groupId).filter((e) => e);
      const data = { userId, groupId };
      const body = { data, access: type };
      await apiClient.post(`${API_URL}${ADDNEWUSERS}/${shareMoadalData?.id}`, body);
    } catch (error) {}
  };

  var accesControls = [
    {
      name: "View",
      access: "PUBLIC",
      info: "Anyone in this group with the link can view",
      iconURL: <EyeIcon/>,
    },
    {
      name: "Restricted",
      access: "PRIVATE",
      info: "Only people with access can open with the link",
      iconURL: <Lock/>,
    },
    {
      name: "Anyone with the link",
      access: "ANYONE",
      info: "Anyone on the internet with the link can view",
      iconURL: <PublicIcon/>,
    },
  ];

  let debounceTimeout;
  const searchGroup = async (querySearch) => {
    if (querySearch === "") return;
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(async () => {
      try {
        const data = await apiClient.get(`${UNO_URL}/api/resource/searchGroupsByChannel`, {
          params: { querySearch },
        });
        if (!data) return;
        let groupIds = [];
        let groupOptionsList = data?.map((e) => {
          groupIds.push(e.uuid);
          return {
            value: { groupId: e.uuid },
            name: e.name,
            label: (
              <div className="User-list" key={e?.uuid}>
                <div className="profile-img">
                  {" "}
                  {e?.avatar ? (
                    <img src={e?.avatar} alt="profile" />
                  ) : (
                    <span className="ini"> {e?.name?.charAt(0)} </span>
                  )}
                </div>
                <div className="name-email">
                  <p className="name">{e?.name}</p>
                </div>
              </div>
            ),
          };
        });
        setOptionList((prev) => {
          const preGroupIds = boardInfo.allocations.filter((e) => e.groupId).map((e) => e?.groupId);
          const optionGroupIds = prev.filter((e) => e.value.groupId).map((e) => e.value.groupId);
          const previousGroups = prev.filter((e) => !preGroupIds.includes(e?.value?.groupId));
          const newGroups = groupOptionsList.filter(
            (e) => !preGroupIds.includes(e?.value?.groupId) && !optionGroupIds.includes(e?.value?.groupId)
          );
          return [...previousGroups, ...newGroups];
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }, 1000);
  };

  useEffect(() => {
    if (API_URL && shareMoadalData && shareMoadalData.id) {
      getSingleBoardDetail();
    }
  }, [API_URL, shareMoadalData]);

  return (
    <Modal centered show={show} onHide={() => cleanModalData()} backdrop={true} keyboard={false}>
      <Modal.Header className="modalheader">
        {boardInfo?.title}
        <span onClick={() => cleanModalData()}>
          <CloseIcon />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="slide-share">
          <div className="select-user-group">
            <div className="share-user">
              <Select
                options={optionList}
                components={{ MultiValueLabel }}
                getOptionLabel={(item) => item.label}
                isMulti
                name="usersList"
                value={selectedUsers}
                placeholder="Select user"
                filterOption={(option, inputValue) =>
                  option?.data?.name?.toLowerCase().includes(inputValue?.toLowerCase())
                }
                onChange={handleSelectUsers}
                onInputChange={(newValue, actionMeta) => {
                  searchGroup(newValue);
                }}
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  colors: {
                    ...theme.colors,
                    primary50: "#ca373c50",
                    primary25: "#ca373c50",
                    primary: "#ca373c70",
                    danger: "#000000",
                    neutral30: "#00000050",
                  },
                })}
              />
            </div>

            {selectedUsers && selectedUsers.length > 0 && (
              <div className="share-option searchdrpdown">
                <Dropdown className="edit-dropdown">
                  <Dropdown.Toggle variant="light" id="dropdown-basic">
                    {type === "EDIT" ? "Edit" : "Read"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {["READ","EDIT"].map((role, i) => {
                      return (
                        <Dropdown.Item
                          key={i}
                          className={`menu-item ${type === role ? "selected" : ""}`}
                          eventKey={role?.charAt(0).toUpperCase() + role?.slice(1)}
                          onClick={() => setType(() => role)}
                        >
                        <span> <span className="checkicon"> {type === role && <CheckIcon />}</span> {role?.charAt(0)+ role?.slice(1).toLocaleLowerCase()} </span>
                        </Dropdown.Item>
                      );
                    })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            )}
          </div>

          <div className="shared-list">
            <h6>Who has access</h6>
            <div className="people-list">
              {loader ? (
                <>
                  <div className="w-100 mb-1 ">
                    <Skeleton width="100%" height="1.8rem" />
                  </div>
                  <div className="w-100 mb-1">
                    <Skeleton width="100%" height="1.8rem" />
                  </div>
                  <div className="w-100 mb-1">
                    <Skeleton width="100%" height="1.8rem" />
                  </div>
                  <div className="w-100 mb-1">
                    <Skeleton width="100%" height="1.8rem" />
                  </div>
                </>
              ) : (
                <>
                  {boardInfo?.allocations?.map((board, i) => {
                    return (
                      <div
                        key={i}
                        className={board.access === "REMOVE" ? "individual remove-individual" : "individual"}
                      >
                        <div className="profile">
                          {board?.avatar ? (
                            <img src={board?.avatar} />
                          ) : (
                            <span className="ini">{board?.name?.charAt(0)}</span>
                          )}
                          <div className="name-email">
                            <p> {board?.name} </p>
                            <p> {board?.email} </p>
                          </div>
                        </div>

                        <Dropdown className="edit-dropdown whohasaccess">
                          <Dropdown.Toggle variant="light" id="dropdown-basic" disabled={board.access === "OWNER"}>
                            {board?.access?.charAt(0)+board?.access?.slice(1).toLowerCase()}
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {["READ", "EDIT", "REMOVE"].map((access, i) => {
                              return (
                                <Dropdown.Item
                                  key={i}
                                  onClick={() => {
                                    board.userId
                                      ? handleUserTypeChange(board.userId, "", access)
                                      : handleUserTypeChange("", board.groupId, access);
                                  }}
                                  className={board.access === access ? "menu-item selected" : "menu-item"}
                                >
                                 <span> <span className="checkicon">{board.access === access ? <CheckIcon /> : ""}</span> {access?.charAt(0)+access?.slice(1).toLowerCase()} </span> 
                                </Dropdown.Item>
                              );
                            })}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="">
          <h6>General Access</h6>
          <div className="share-option">
            <Dropdown className="edit-dropdown generalaccess">
              <Dropdown.Toggle variant="light" id="dropdown-basic" disabled={boardInfo?.access !== "OWNER"}>
                <div className="shareopdata">
                  <div className="sicon">
                    {accesControls.filter((e) => e.access === boardInfo?.accessType)[0]?.iconURL}
                  </div>
                  <div>
                    <h6 className="sheading">
                      {accesControls.filter((e) => e.access === boardInfo?.accessType)[0]?.name}
                      <CaretIcon/>
                    </h6>
                    <p className="sdescription">
                      {" "}
                      {accesControls.filter((e) => e.access === boardInfo?.accessType)[0]?.info}
                    </p>
                  </div>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {accesControls?.map((ele, i) => {
                  return (
                    <Dropdown.Item
                      key={i}
                      className={boardInfo?.accessType === ele.access ? "menu-item selected" : "menu-item"}
                      onClick={(e) => handleBoardPermission(ele.access)}
                    >
                      <span> <span className="checkicon">{boardInfo?.accessType === ele?.access ? <CheckIcon /> : ""}</span> {ele?.name}</span>
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="footerbtn">
        <button
          id="copy-link"
          onClick={() => {
            let type = boardInfo.accessType !== "PRIVATE" ? "public" : "private";
            navigator.clipboard.writeText(`${window.location.hostname}/board/${type}/${boardInfo.uuid} `);
          }}
        >
          <CopyLink /> Copy Link{" "}
        </button>
        <button disabled={boardInfo?.access === "READ"} className={boardInfo?.access === "READ" ? "disable":"loading share"} onClick={() => saveBoardUsersInfo()} >
          {loading ? (
            <svg viewBox="25 25 50 50" className="spinner">
            <circle r="20" cy="50" cx="50" strokeWidth="4" fill="none" />
          </svg>
            
          ) : (
            "Save"
          )}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShareModal;
